<template>
    <div class="d-flex flex-wrap">
        <div class="container-fluid p-0">
            <slot />
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
    localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? import('./components/header/theme/header.scss') : import('./components/header/theme/header-rtl.scss');

    export default {
        name: 'no-navbar',
        components: {

        },
        data: () => ({

        }),
    };
</script>

<style lang="scss" scoped></style>